import React, { useMemo } from 'react';
import useData from '../../hooks/useData';
import { QuoteIcon } from '../ui/Icons';

const QuoteMetricsWidget = () => {
    const { quotes, currentUserProfile } = useData();

    const metrics = useMemo(() => {
        if (!currentUserProfile) {
            return { sentOrApprovedValue: 0, conversionRate: 0, awaitingResponse: 0 };
        }

        const { monthlySalary = 4000, workHoursPerMonth = 160, costFactor = 1.5 } = currentUserProfile;
        const hourlyRate = (monthlySalary * costFactor) / workHoursPerMonth;

        let sentOrApprovedValue = 0;
        let approvedCount = 0;
        let sentCount = 0;

        quotes.forEach(quote => {
            if (quote.status === 'Rascunho') return;

            const total = (quote.items || []).reduce((acc, item) => acc + (item.hours || 0) * (item.qty || 1) * hourlyRate, 0);
            
            if (quote.status === 'Aprovado' || quote.status === 'Enviado') {
                sentOrApprovedValue += total;
            }

            if (quote.status === 'Aprovado') {
                approvedCount++;
            }
            if (quote.status === 'Enviado' || quote.status === 'Aprovado') {
                sentCount++;
            }
        });

        const conversionRate = sentCount > 0 ? (approvedCount / sentCount) * 100 : 0;
        const awaitingResponse = quotes.filter(q => q.status === 'Enviado').length;

        return {
            sentOrApprovedValue,
            conversionRate,
            awaitingResponse
        };
    }, [quotes, currentUserProfile]);

    return (
        <div className="p-4 h-full flex flex-col animate-fade-in" style={{ animationDelay: '400ms' }}>
            <div className="flex items-center gap-2 mb-3">
                <QuoteIcon size={16} className="text-indigo-300"/>
                <h3 className="text-lg font-bold text-white">Orçamentos</h3>
            </div>
            {/* --- INÍCIO DA ALTERAÇÃO --- */}
            <div className="space-y-3 flex-grow flex flex-col justify-center text-center">
            {/* --- FIM DA ALTERAÇÃO --- */}
                <div>
                    <p className="text-3xl font-bold text-emerald-400">
                        {metrics.sentOrApprovedValue.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                    </p>
                    <p className="text-xs text-gray-300">Valor em propostas ativas</p>
                </div>
                <div className="flex justify-around">
                    <div>
                        <p className="text-2xl font-bold text-sky-400">{metrics.awaitingResponse}</p>
                        <p className="text-xs text-gray-300">Aguardando</p>
                    </div>
                    <div>
                        <p className="text-2xl font-bold text-pink-400">{metrics.conversionRate.toFixed(0)}%</p>
                        <p className="text-xs text-gray-300">Conversão</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default QuoteMetricsWidget;